const ONE_HOUR_MS = 60 * 60 * 1000;
const ONE_DAY_MS = 24 * ONE_HOUR_MS;
const DEFAULT_BUILD_EXPIRY_MS = 2 * ONE_DAY_MS + 2 * ONE_HOUR_MS;
export function isBuildExpiryEnabled() {
    return typeof __CMS_MFE_BUILD_EXPIRY_ENABLED__ !== 'undefined' && __CMS_MFE_BUILD_EXPIRY_ENABLED__;
}
export function getBuildTimeMs() {
    return typeof __CMS_MFE_BUILD_TIME__ !== 'undefined' ? __CMS_MFE_BUILD_TIME__ : 0;
}
export function getBuildExpiryMs() {
    if (typeof __CMS_MFE_BUILD_EXPIRY_MS__ !== 'undefined' && __CMS_MFE_BUILD_EXPIRY_MS__ > 0) {
        return __CMS_MFE_BUILD_EXPIRY_MS__;
    }
    return DEFAULT_BUILD_EXPIRY_MS;
}
export function getBuildExpiresAtMs() {
    if (!isBuildExpiryEnabled()) {
        return null;
    }
    const buildTime = getBuildTimeMs();
    if (!buildTime) {
        return null;
    }
    return buildTime + getBuildExpiryMs();
}
export function getRemainingMs(now = Date.now()) {
    const expiresAt = getBuildExpiresAtMs();
    if (expiresAt == null) {
        return Number.POSITIVE_INFINITY;
    }
    return Math.max(0, expiresAt - now);
}
export function isBuildExpired(now = Date.now()) {
    if (!isBuildExpiryEnabled()) {
        return false;
    }
    return getRemainingMs(now) <= 0;
}
export function splitRemainingMs(ms) {
    const totalSeconds = Math.max(0, Math.floor(ms / 1000));
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return { days, hours, minutes, seconds };
}
export function padTimeUnit(value) {
    return String(value).padStart(2, '0');
}
